import { createSelector } from 'reselect';

export const guestServicesRequestsContainer = ({ guestServicesRequests }) => guestServicesRequests;

export const guestServicesRequestsSelector = createSelector(
  [guestServicesRequestsContainer],
  (guestServicesRequests) => ({ guestServicesRequests }),
);
